<style lang="scss" scoped>
.title {
  color: #333333;
  font-family: 'Open Sans';
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 22px;
  max-width: 300px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.custom-labels {
  ::v-deep label {
    color: #333333;
    font-family: 'Open Sans';
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 24px;
    margin-bottom: 5px !important;
    .text-danger {
      font-size: 0.73333rem;
    }
  }
}
::v-deep .image-input {
  justify-content: center;
  .preview-img {
    width: 80%;
    align-self: center;
  }
}
</style>

<template>
  <create-layout v-if="data" :data="data">
    <template slot="title-bar">
      <div class="title">
        {{ action === 'update' ? template.title : 'Nieuwe template' }}
      </div>
      <template v-if="data.parent_id === null">
        <div v-if="data.hasOwnProperty('id')" class="box clickable" @click="$router.push({ name: 'admin-template-groups', params: { templateId: data.id } })">
          <i class="fal fa-money-check-edit"></i>
        </div>
      </template>
      <template v-else>
        <div v-if="data.hasOwnProperty('id')" class="box clickable" @click="$router.push({ name: 'workspace-template-groups', params: { workspaceId: data.parent_id, templateId: data.id } })">
          <i class="fal fa-money-check-edit"></i>
        </div>
      </template>
      <div class="ml-auto d-flex">
        <dropdown-layout v-if="data.id" ref="dropdown" class="box border-left-0 clickable position-relative ">
          <template v-slot:handle>
            <i class="fal fa-ellipsis-v fa-2x"></i>
          </template>
          <template v-slot:items>
            <div class="item fs-15 d-flex fw-n ff-l" @click.stop="duplicate()">
              <i class="fal fa-folders mr-15 my-auto"></i>
              {{ $t(`${$options.name}.duplicate`) }}
            </div>
            <div class="item fs-15 text-danger d-flex fw-n ff-l" @click.stop="remove()">
              <i class="fal fa-trash mr-15 my-auto"></i>
              {{ $t(`${$options.name}.delete`) }}
            </div>
          </template>
        </dropdown-layout>
        <div class="box border-left-0 border-right-0 pr-0">
          <a href="#" class="btn btn-primary" @click="fakeSubmit()">{{ $t(`${$options.name}.button_${action}_submit`) }}</a>
        </div>
      </div>
    </template>
    <template slot="side-bar">
      <el-form ref="form" class="w-100" @submit="submit()" :error="server_error" :loading="loading" :success="success" :button-text="`${$options.name}.button_${action}`">
        <div class="form-row">
          <el-input v-model="data.title" class="col-12 custom-labels" rule="required|min:2|max:255" name="template_title" />
          <el-input v-model="data.subtitle" class="col-12 custom-labels" rule="min:2|max:255" name="template_subtitle" />
          <div v-if="workspaces && data.parent_id === null" class="col-12 custom-labels mb-15">
            <label for="">{{ $t('views.admin.user.workspaces') }}</label>
            <multi-list-select :list="workspaces" optionValue="id" optionText="name" :selectedItems="data.workspaces" @select="onWorkspaceSelect" placeholder="select workspace"></multi-list-select>
          </div>
          <el-image-input
            v-validate.immediate="'size:2048'"
            v-model="data.logo"
            :preview="data.logo_preview"
            @preview="
              $event => {
                data.logo_preview = $event;
              }
            "
            :hide="['url', 'google', 'dropbox', 'onedrive', 'library']"
            class="col-12 custom-labels"
            @reset="resetLogo"
            @delete="resetLogo"
            :multiple="false"
            layout="small"
            padding="90px 200px"
            name="template_logo"
            :placeholder="$t(`forms.placeholders.template_logo`)"
            @on-error="imageError => (server_error = { error: imageError })"
          />
          <div class="col-12 custom-labels">
            <label>{{ $t(`${$options.name}.basic_info`) }}</label>
          </div>
          <div class="col-12 mb-8">
            <div class="custom-control custom-checkbox">
              <input v-model="data.company" type="checkbox" name="templateCompany" class="custom-control-input" id="templateCompany" />
              <label class="custom-control-label" for="templateCompany">
                {{ $t(`forms.labels.template_company`) }}
              </label>
            </div>
          </div>
          <div class="col-12 mb-8">
            <div class="custom-control custom-checkbox">
              <input v-model="data.date" type="checkbox" name="templateDate" class="custom-control-input" id="templateDate" />
              <label class="custom-control-label" for="templateDate">
                {{ $t(`forms.labels.template_date`) }}
              </label>
            </div>
          </div>
          <div class="col-12 mb-8">
            <div class="custom-control custom-checkbox">
              <input v-model="data.participants" type="checkbox" name="templateParticipants" class="custom-control-input" id="templateParticipants" />
              <label class="custom-control-label" for="templateParticipants">
                {{ $t(`forms.labels.template_participants`) }}
              </label>
            </div>
          </div>
          <div class="col-12 mb-30">
            <div class="custom-control custom-checkbox">
              <input v-model="data.message" type="checkbox" name="templateMessage" class="custom-control-input" id="templateMessage" />
              <label class="custom-control-label" for="templateMessage">
                {{ $t(`forms.labels.template_message`) }}
              </label>
            </div>
          </div>
          <div class="col-12 custom-labels">
            <label>{{ $t(`${$options.name}.usage`) }}</label>
          </div>
          <div class="col-12 col-md-8">
            <p>{{ $t(`${$options.name}.multiple_uses`) }}</p>
          </div>
          <div class="col-12 col-md-4">
            <el-select
              class="mb-15"
              v-model="data.multiUse"
              name="multiUse"
              :options="[
                { value: 1, label: $t('general.yes') },
                { value: 0, label: $t('general.no') },
              ]"
              :hasLabel="false"
              placeholder=""
            ></el-select>
          </div>
          <div class="col-12 col-md-8">
            <p>{{ $t(`${$options.name}.user_view_submissions`) }}</p>
          </div>
          <div class="col-12 col-md-4">
            <el-select
              class="mb-15"
              v-model="data.public"
              name="public"
              :options="[
                { value: 1, label: $t('general.yes') },
                { value: 0, label: $t('general.no') },
              ]"
              :hasLabel="false"
              placeholder=""
            ></el-select>
          </div>
          <div class="col-12 col-md-8">
            <p>{{ $t(`${$options.name}.multiple_uses_per_object`) }}</p>
          </div>
          <div class="col-12 col-md-4">
            <el-select
              class="mb-15"
              v-model="data.reusable"
              name="reusable"
              :options="[
                { value: 1, label: $t('general.yes') },
                { value: 0, label: $t('general.no') },
              ]"
              :hasLabel="false"
              placeholder=""
            ></el-select>
          </div>
        </div>
        <template slot="footerLeft">
          &nbsp;
        </template>
        <template slot="footerRight">
          &nbsp;
        </template>
      </el-form>
    </template>
  </create-layout>
</template>

<script>
import HasForm from '@/components/forms/has-form';
import ElImageInput from '@/components/elements/image-input';
import CreateLayout from './create-layout';
import { MultiListSelect } from 'vue-search-select';
import RemovePopup from '@/popups/general/remove';
import DropdownLayout from '@/layouts/dropdown';

export default {
  name: 'views.admin.templates-create',

  mixins: [HasForm],

  props: {
    type: {
      required: false,
      default: 'admin',
    },
    template: {
      required: false,
      default: () => ({
        title: '',
        subtitle: '',
        logo_preview: [],
        logo: [],
        date: true,
        company: true,
        participants: true,
        message: true,
        parent_id: null,
        multiUse: 0,
        public: 0,
        reusable: 0,
        workspaces: [],
      }),
    },
    action: {
      default: 'create',
    },
  },

  components: {
    MultiListSelect,
    ElImageInput,
    CreateLayout,
    DropdownLayout,
    ElForm: () => import(/* webpackChunkName: "elements" */ '@/components/forms/ElForm'),
    ElInput: () => import(/* webpackChunkName: "elements" */ '@/components/forms/ElInput'),
    ElSelect: () => import(/* webpackChunkName: "elements" */ '@/components/forms/ElSelect'),
  },

  data: vm => ({
    data: JSON.parse(JSON.stringify(vm.template)),
  }),

  methods: {
    remove() {
      this.$modal.show(RemovePopup, { onSuccess: this.handleRemoveOnSuccess, modelId: this.data.id, modelTitle: this.data.title, type: 'template' }, { adaptive: true, height: 'auto', width: '400' });
      this.$refs.dropdown.open = false;
    },
    handleRemoveOnSuccess() {
      this.$router.push({ name: 'admin-templates' });
    },
    onWorkspaceSelect(items) {
      this.data.workspaces = items;
    },
    fakeSubmit() {
      this.$refs.form.submit();
    },
    submit() {
      this.loading = true;
      this.$store.dispatch(`template/${this.action}`, this.data).then(data => {
        if (data.parent_id === null) {
          this.$router.push({ name: 'admin-template-groups', params: { templateId: data.id } });
        } else {
          this.$router.push({ name: 'workspace-template-groups', params: { workspaceId: data.parent_id, templateId: data.id } });
        }
      });
    },
    resetLogo() {
      this.data.logo = [];
    },
    duplicate() {
      const id = this.data.id;
      this.$store.dispatch('template/duplicate', id).then(template => {
        this.$toasted.show(this.toastHtml('Template duplicated!'), {
          theme: 'outline',
          position: 'bottom-right',
          duration: 5000,
        });
        if (this.data.parent_id === null) {
          this.$router.push({ name: 'admin-template-update', params: { templateId: template.id } });
        } else {
          this.$router.push({ name: 'workspace-template-update', params: { workspaceId: template.parent_id, templateId: template.id } });
        }
      });
    },
  },

  computed: {
    workspaces() {
      return this.$store.getters['admin/workspacesList'];
    },
  },

  watch: {
    template: {
      handler: function(newVal) {
        this.data = JSON.parse(JSON.stringify(newVal));
      },
      deep: true,
    },
  },
};
</script>
